import { useUpdateField } from '../useUpdateField';
import { useBriefSetBooleanMutation } from './briefSetBoolean.generated';

export function useUpdateBooleanField(
    key: string,
    briefId?: string,
    initialValue?: boolean | null
) {
    const [setBoolean] = useBriefSetBooleanMutation();
    return useUpdateField({ key, setField: setBoolean, briefId, initialValue });
}
